"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRAND_LOGOS = void 0;
/* eslint-disable prettier/prettier */
const assets_1 = require("./assets");
const mnexspike_logo_1 = require("./assets/mnexspike-logo");
exports.BRAND_LOGOS = {
    "bench-2-practice": assets_1.Bench2Practice,
    "mnexspike-logo": mnexspike_logo_1.MNexSpikeLogo,
    "moderna-atlas": assets_1.ModernaAtlas,
    "moderna-logo-white": assets_1.ModernaLogoWhite,
    "moderna-logo": assets_1.ModernaLogo,
    "mresvia-logo": assets_1.MresviaLogo,
    "mrna-access": assets_1.MrnaAccess,
    "spikevax-elasomeran": assets_1.SpikevaxElasomeran,
    "spikevax-kr": assets_1.SpikevaxKr,
    "spikevax-moderna": assets_1.SpikevaxModerna,
    "spikevax-navbar": assets_1.SpikevaxNavbar,
    "spikevax-registered-french": assets_1.SpikevaxRegisteredFrench,
    "spikevax-registered": assets_1.SpikevaxRegistered,
    "spikevax": assets_1.Spikevax
};
//# sourceMappingURL=BrandLogoConsts.js.map